export enum SectionCommunityTypes {
  AllCommunities = 'allCommunities',
  MyCommunitiesPurchases = 'myCommunitiesPurchases',
  PurchasedCommunitiesProjects = 'purchasedCommunitiesProjects',
  TopCommunitiesProjects = 'topCommunitiesProjects',
  TopEmissionReductions = 'topEmissionReductions',
  NewCommunitiesProjects = 'newCommunitiesProjects',
}

export const sectionCommunitySizeMap: { [key: string]: number } = {
  [SectionCommunityTypes.AllCommunities]: 12,
  [SectionCommunityTypes.TopCommunitiesProjects]: 3,
  [SectionCommunityTypes.MyCommunitiesPurchases]: 4,
  [SectionCommunityTypes.PurchasedCommunitiesProjects]: 4,
  [SectionCommunityTypes.TopEmissionReductions]: 4,
  [SectionCommunityTypes.NewCommunitiesProjects]: 4,
};

interface CommunityParams {
  limit?: number;
  sortBy?: string;
  sortOrder?: string;
}

export const paramsCommunityMap: { [key: string]: CommunityParams } = {
  [SectionCommunityTypes.AllCommunities]: { limit: 8 },
  [SectionCommunityTypes.TopCommunitiesProjects]: { limit: 3, sortBy: 'score' },
  [SectionCommunityTypes.TopEmissionReductions]: { limit: 6, sortBy: 'emissionReductions' },
  [SectionCommunityTypes.NewCommunitiesProjects]: { limit: 6, sortBy: 'createdAt' },
};
